import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as intro from 'apiSaga/apiIntro';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/
// 0. Response 초기화
const INIT_INTRO_RESP = 'intro/INIT_INTRO_RESP';
const INIT_FAQ_INTRO_LIST_RESP = 'intro/INIT_FAQ_INTRO_LIST_RESP';
const INIT_NOTICE_INTRO_LIST_RESP = 'intro/INIT_NOTICE_INTRO_LIST_RESP';
const INIT_NOTICE_INTRO_DETAIL_VIEW_RESP = 'intro/INIT_NOTICE_INTRO_DETAIL_VIEW_RESP';
const INIT_ALL_NOTICE_POPUP_NON_LOGIN_LIST_RESP = 'intro/INIT_ALL_NOTICE_POPUP_NON_LOGIN_LIST_RESP';
const INIT_NOTICE_INTRO_FILE_DOWN_RESP = 'intro/INIT_NOTICE_INTRO_FILE_DOWN_RESP';
const INIT_DOCUMENT_FILE_DOWNLOAD_RESP = 'intro/INIT_DOCUMENT_FILE_DOWNLOAD_RESP';
const INIT_POLICY_MNGT_LIST_RESP = 'intro/INIT_POLICY_MNGT_LIST_RESP';
const INIT_INSERT_REQST_CONSULT_RESP = 'intro/INIT_INSERT_REQST_CONSULT_RESP';
const INIT_TERMS_OF_SERVICE_RESP = 'intro/INIT_TERMS_OF_SERVICE_RESP';
const INIT_PERSONAL_TERMS_RESP = 'intro/INIT_PERSONAL_TERMS_RESP';
const INIT_GET_IFAQ_TYPE_LIST_RESP = 'svcCntr/INIT_GET_IFAQ_TYPE_LIST_RESP';
const INIT_INSERT_REQST_PROPOSAL_RESP = 'intro/INIT_INSERT_REQST_PROPOSAL_RESP';
const INIT_GET_PROPOSAL_PRIVACY_POLICY_RESP = 'intro/INIT_GET_PROPOSAL_PRIVACY_POLICY_RESP';
const INIT_GET_PROPOSAL_NOTICE_POLICY_RESP = 'intro/INIT_GET_PROPOSAL_NOTICE_POLICY_RESP';
// FAQ 드롭다운 리스트
const GET_IFAQ_TYPE_LIST = 'svcCntr/GET_IFAQ_TYPE_LIST';
const GET_IFAQ_TYPE_LIST_SUCCESS = 'svcCntr/GET_IFAQ_TYPE_LIST_SUCCESS';
const GET_IFAQ_TYPE_LIST_FAILURE = 'svcCntr/GET_IFAQ_TYPE_LIST_FAILURE';
// U001: FAQ 목록 리스트
const FAQ_INTRO_LIST = 'intro/FAQ_INTRO_LIST';
const FAQ_INTRO_LIST_SUCCESS = 'intro/FAQ_INTRO_LIST_SUCCESS';
const FAQ_INTRO_LIST_FAILURE = 'intro/FAQ_INTRO_LIST_FAILURE';
// U002: 공지사항 목록 리스트
const NOTICE_INTRO_LIST = 'intro/NOTICE_INTRO_LIST';
const NOTICE_INTRO_LIST_SUCCESS = 'intro/NOTICE_INTRO_LIST_SUCCESS';
const NOTICE_INTRO_LIST_FAILURE = 'intro/NOTICE_INTRO_LIST_FAILURE';
// U003: 공지사항 상세 조회
const NOTICE_INTRO_DETAIL_VIEW = 'intro/NOTICE_INTRO_DETAIL_VIEW';
const NOTICE_INTRO_DETAIL_VIEW_SUCCESS = 'intro/NOTICE_INTRO_DETAIL_VIEW_SUCCESS';
const NOTICE_INTRO_DETAIL_VIEW_FAILURE = 'intro/NOTICE_INTRO_DETAIL_VIEW_FAILURE';
// U004: 인트로 팝업
const ALL_NOTICE_POPUP_NON_LOGIN_LIST = 'intro/ALL_NOTICE_POPUP_NON_LOGIN_LIST';
const ALL_NOTICE_POPUP_NON_LOGIN_LIST_SUCCESS = 'intro/ALL_NOTICE_POPUP_NON_LOGIN_LIST_SUCCESS';
const ALL_NOTICE_POPUP_NON_LOGIN_LIST_FAILURE = 'intro/ALL_NOTICE_POPUP_NON_LOGIN_LIST_FAILURE';
// U066: 공지사항 인트로 파일 다운로드
const NOTICE_INTRO_FILE_DOWN = 'intro/NOTICE_INTRO_FILE_DOWN';
const NOTICE_INTRO_FILE_DOWN_SUCCESS = 'intro/NOTICE_INTRO_FILE_DOWN_SUCCESS';
const NOTICE_INTRO_FILE_DOWN_FAILURE = 'intro/NOTICE_INTRO_FILE_DOWN_FAILURE';
// U0104: 스파로스 서비스 소개서 다운로드
const DOCUMENT_FILE_DOWNLOAD = 'intro/DOCUMENT_FILE_DOWNLOAD';
const DOCUMENT_FILE_DOWNLOAD_SUCCESS = 'intro/DOCUMENT_FILE_DOWNLOAD_SUCCESS';
const DOCUMENT_FILE_DOWNLOAD_FAILURE = 'intro/DOCUMENT_FILE_DOWNLOAD_FAILURE';
// U1310: 인트로 상담신청 - 상담 신청 페이지 정책 조회
const POLICY_MNGT_LIST = 'intro/POLICY_MNGT_LIST';
const POLICY_MNGT_LIST_SUCCESS = 'intro/POLICY_MNGT_LIST_SUCCESS';
const POLICY_MNGT_LIST_FAILURE = 'intro/POLICY_MNGT_LIST_FAILURE';
// U1311. 인트로 상담신청 - 상담 신청 등록
const INERT_REQST_CONSULT = 'intro/INERT_REQST_CONSULT';
const INERT_REQST_CONSULT_SUCCESS = 'intro/INERT_REQST_CONSULT_SUCCESS';
const INERT_REQST_CONSULT_FAILURE = 'intro/INERT_REQST_CONSULT_FAILURE';
// U1312: 인트로 상담신청 - 서비스 이용약관
const TERMS_OF_SERVICE = 'intro/TERMS_OF_SERVICE';
const TERMS_OF_SERVICE_SUCCESS = 'intro/TERMS_OF_SERVICE_SUCCESS';
const TERMS_OF_SERVICE_FAILURE = 'intro/TERMS_OF_SERVICE_FAILURE';
// U1313: 인트로 상담신청 - 개인정보처리방침
const PERSONAL_TERMS = 'intro/PERSONAL_TERMS';
const PERSONAL_TERMS_SUCCESS = 'intro/PERSONAL_TERMS_SUCCESS';
const PERSONAL_TERMS_FAILURE = 'intro/PERSONAL_TERMS_FAILURE';
// 인트로 서비스 제휴제안 - 제휴제안 등록
const INERT_REQST_PROPOSAL = 'intro/INERT_REQST_PROPOSAL';
const INERT_REQST_PROPOSAL_SUCCESS = 'intro/INERT_REQST_PROPOSAL_SUCCESS';
const INERT_REQST_PROPOSAL_FAILURE = 'intro/INERT_REQST_PROPOSAL_FAILURE';
// 인트로 서비스 제휴제안 - 개인정보 수집 및 이용 동의 정책 조회
const GET_PROPOSAL_PRIVACY_POLICY = 'intro/GET_PROPOSAL_PRIVACY_POLICY';
const GET_PROPOSAL_PRIVACY_POLICY_SUCCESS = 'intro/GET_PROPOSAL_PRIVACY_POLICY_SUCCESS';
const GET_PROPOSAL_PRIVACY_POLICY_FAILURE = 'intro/GET_PROPOSAL_PRIVACY_POLICY_FAILURE';
// 인트로 서비스 제휴제안 - 유의사항 정책 조회
const GET_PROPOSAL_NOTICE_POLICY = 'intro/GET_PROPOSAL_NOTICE_POLICY';
const GET_PROPOSAL_NOTICE_POLICY_SUCCESS = 'intro/GET_PROPOSAL_NOTICE_POLICY_SUCCESS';
const GET_PROPOSAL_NOTICE_POLICY_FAILURE = 'intro/GET_PROPOSAL_NOTICE_POLICY_FAILURE';

// 0. Response 초기화
export const initIntroResp = createAction(INIT_INTRO_RESP);
export const initFaqIntroListResp = createAction(INIT_FAQ_INTRO_LIST_RESP);
export const initNoticeIntroListResp = createAction(INIT_NOTICE_INTRO_LIST_RESP);
export const initNoticeIntroDetailViewResp = createAction(INIT_NOTICE_INTRO_DETAIL_VIEW_RESP);
export const initAllNoticePopupNonLoginListResp = createAction(INIT_ALL_NOTICE_POPUP_NON_LOGIN_LIST_RESP);
export const initNoticeIntrofileDownResp = createAction(INIT_NOTICE_INTRO_FILE_DOWN_RESP);
export const initDocumentFileDownloadResp = createAction(INIT_DOCUMENT_FILE_DOWNLOAD_RESP);
export const initPolicyMngtListResp = createAction(INIT_POLICY_MNGT_LIST_RESP);
export const initInsertReqstConsultResp = createAction(INIT_INSERT_REQST_CONSULT_RESP);
export const initTermsOfServiceResp = createAction(INIT_TERMS_OF_SERVICE_RESP);
export const initPersonalTermsResp = createAction(INIT_PERSONAL_TERMS_RESP);
export const initgetIFaqTypeListResp = createAction(INIT_GET_IFAQ_TYPE_LIST_RESP);
export const initInsertReqstProposalResp = createAction(INIT_INSERT_REQST_PROPOSAL_RESP);
export const initGetProposalPrivacyPolicyResp = createAction(INIT_GET_PROPOSAL_PRIVACY_POLICY_RESP);
export const initGetProposalNoticePolicyResp = createAction(INIT_GET_PROPOSAL_NOTICE_POLICY_RESP);
// U001: FAQ 목록 리스트
export const getFaqIntroList = createAction(FAQ_INTRO_LIST, (filePk) => filePk);
// U002: 공지사항 인트로 목록 리스트
export const getNoticeIntroList = createAction(NOTICE_INTRO_LIST, (dataParam) => dataParam);
// U003: 공지사항 인트로 상세 보기
export const getNoticeIntroDetailView = createAction(NOTICE_INTRO_DETAIL_VIEW, (dataParam) => dataParam);
// U004: 인트로 팝업
export const getAllNoticePopupNonLoginList = createAction(ALL_NOTICE_POPUP_NON_LOGIN_LIST);
// U066: 공지사항 인트로 파일 다운로드
export const noticeIntrofileDown = createAction(NOTICE_INTRO_FILE_DOWN, (fileSeq) => fileSeq);
// U0104: 스파로스 서비스 소개서 다운로드
export const documentFileDownload = createAction(DOCUMENT_FILE_DOWNLOAD, (type) => type);
// U1310: 인트로 상담신청 - 상담 신청 페이지 정책 조회
export const getPolicyMngtList = createAction(POLICY_MNGT_LIST);
// U1311. 인트로 상담신청 - 상담 신청 등록
export const insertReqstConsult = createAction(INERT_REQST_CONSULT, (dataParam) => dataParam);
// U1312: 인트로 상담신청 - 서비스 이용약관
export const getTermsOfService = createAction(TERMS_OF_SERVICE, (policySeq) => policySeq);
// U1313: 인트로 상담신청 - 개인정보처리방침
export const getPersonalTerms = createAction(PERSONAL_TERMS, (policySeq) => policySeq);
// FAQ 드롭다운 리스트
export const getIFaqTypeList = createAction(GET_IFAQ_TYPE_LIST);
// 인트로 서비스 제휴제안 - 제휴제안 등록
export const insertReqstProposal = createAction(INERT_REQST_PROPOSAL, (dataParam) => dataParam);
// 인트로 서비스 제휴제안 - 개인정보 수집 및 이용 동의 정책 조회
export const getProposalPrivacyPolicy = createAction(GET_PROPOSAL_PRIVACY_POLICY);
// 인트로 서비스 제휴제안 - 유의사항 정책 조회
export const getProposalNoticePolicy = createAction(GET_PROPOSAL_NOTICE_POLICY);

const getFaqIntroListSaga = createRequestSaga(FAQ_INTRO_LIST, intro.getFaqIntroList);
const getNoticeIntroListSaga = createRequestSaga(NOTICE_INTRO_LIST, intro.getNoticeIntroList);
const getNoticeIntroDetailViewSaga = createRequestSaga(NOTICE_INTRO_DETAIL_VIEW, intro.getNoticeIntroDetailView);
const getAllNoticePopupNonLoginListSaga = createRequestSaga(
  ALL_NOTICE_POPUP_NON_LOGIN_LIST,
  intro.getAllNoticePopupNonLoginList
);
const noticeIntrofileDownSaga = createRequestSaga(NOTICE_INTRO_FILE_DOWN, intro.noticeIntrofileDown);
const documentFileDownloadSaga = createRequestSaga(DOCUMENT_FILE_DOWNLOAD, intro.documentFileDownload);
const getPolicyMngtListSaga = createRequestSaga(POLICY_MNGT_LIST, intro.getPolicyMngtList);
const insertReqstConsultSaga = createRequestSaga(INERT_REQST_CONSULT, intro.insertReqstConsult);
const getTermsOfServiceSaga = createRequestSaga(TERMS_OF_SERVICE, intro.getTermsOfService);
const getPersonalTermsSaga = createRequestSaga(PERSONAL_TERMS, intro.getPersonalTerms);
const getIFaqTypeListSaga = createRequestSaga(GET_IFAQ_TYPE_LIST, intro.getIFaqTypeList);
const insertReqstProposalSaga = createRequestSaga(INERT_REQST_PROPOSAL, intro.insertReqstProposal); // 제휴제안 등록
const getProposalPrivacyPolicySaga = createRequestSaga(GET_PROPOSAL_PRIVACY_POLICY, intro.getProposalPrivacyPolicy); // 제휴제안 개인정보 수집 및 이용 동의 정책 조회
const getProposalNoticePolicySaga = createRequestSaga(GET_PROPOSAL_NOTICE_POLICY, intro.getProposalNoticePolicy); // 제휴제안 유의사항 정책 조회

// apiIntroSaga
export function* apiIntroSaga() {
  yield takeLatest(FAQ_INTRO_LIST, getFaqIntroListSaga);
  yield takeLatest(NOTICE_INTRO_LIST, getNoticeIntroListSaga);
  yield takeLatest(NOTICE_INTRO_DETAIL_VIEW, getNoticeIntroDetailViewSaga);
  yield takeLatest(ALL_NOTICE_POPUP_NON_LOGIN_LIST, getAllNoticePopupNonLoginListSaga);
  yield takeLatest(NOTICE_INTRO_FILE_DOWN, noticeIntrofileDownSaga);
  yield takeLatest(DOCUMENT_FILE_DOWNLOAD, documentFileDownloadSaga);
  yield takeLatest(POLICY_MNGT_LIST, getPolicyMngtListSaga);
  yield takeLatest(INERT_REQST_CONSULT, insertReqstConsultSaga);
  yield takeLatest(TERMS_OF_SERVICE, getTermsOfServiceSaga);
  yield takeLatest(PERSONAL_TERMS, getPersonalTermsSaga);
  yield takeLatest(GET_IFAQ_TYPE_LIST, getIFaqTypeListSaga);
  yield takeLatest(INERT_REQST_PROPOSAL, insertReqstProposalSaga);
  yield takeLatest(GET_PROPOSAL_PRIVACY_POLICY, getProposalPrivacyPolicySaga);
  yield takeLatest(GET_PROPOSAL_NOTICE_POLICY, getProposalNoticePolicySaga);
}

// 초기 상태를 선언
// 요청의 로딩 중 상태는 loading 객체에서 관리
const initialState = {
  getFaqIntroListResp: null,
  getNoticeIntroListResp: null,
  getNoticeIntroDetailViewResp: null,
  getAllNoticePopupNonLoginListResp: null,
  noticeIntrofileDownResp: null,
  documentFileDownloadResp: null,
  getPolicyMngtListResp: null,
  insertReqstConsultResp: null,
  getTermsOfServiceResp: null,
  getPersonalTermsResp: null,
  getIFaqTypeListResp: null,
  insertReqstProposalResp: null,
  getProposalPrivacyPolicyResp: null,
  getProposalNoticePolicyResp: null,
};

const apiIntroResp = handleActions(
  {
    // 0. Response 초기화
    [INIT_INTRO_RESP]: (state, action) => ({
      getFaqIntroListResp: null,
      getNoticeIntroListResp: null,
      getNoticeIntroDetailViewResp: null,
      getAllNoticePopupNonLoginListResp: null,
      noticeIntrofileDownResp: null,
      documentFileDownloadResp: null,
      getPolicyMngtListResp: null,
      insertReqstConsultResp: null,
      getTermsOfServiceResp: null,
      getPersonalTermsResp: null,
      getIFaqTypeListResp: null,
      insertReqstProposalResp: null,
      getProposalPrivacyPolicyResp: null,
      getProposalNoticePolicyResp: null,
    }),
    [INIT_GET_IFAQ_TYPE_LIST_RESP]: (state, action) => ({
      ...state,
      getIFaqTypeListResp: null,
    }),
    [INIT_FAQ_INTRO_LIST_RESP]: (state, action) => ({
      ...state,
      getFaqIntroListResp: null,
    }),
    [INIT_NOTICE_INTRO_LIST_RESP]: (state, action) => ({
      ...state,
      getNoticeIntroListResp: null,
    }),
    [INIT_NOTICE_INTRO_DETAIL_VIEW_RESP]: (state, action) => ({
      ...state,
      getNoticeIntroDetailViewResp: null,
    }),
    [INIT_ALL_NOTICE_POPUP_NON_LOGIN_LIST_RESP]: (state, action) => ({
      ...state,
      getAllNoticePopupNonLoginListResp: null,
    }),
    [INIT_NOTICE_INTRO_FILE_DOWN_RESP]: (state, action) => ({
      ...state,
      noticeIntrofileDownResp: null,
    }),
    [INIT_DOCUMENT_FILE_DOWNLOAD_RESP]: (state, action) => ({
      ...state,
      documentFileDownloadResp: null,
    }),
    [INIT_POLICY_MNGT_LIST_RESP]: (state, action) => ({
      ...state,
      getPolicyMngtListResp: null,
    }),
    [INIT_INSERT_REQST_CONSULT_RESP]: (state, action) => ({
      ...state,
      insertReqstConsultResp: null,
    }),
    [INIT_TERMS_OF_SERVICE_RESP]: (state, action) => ({
      ...state,
      getTermsOfServiceResp: null,
    }),
    [INIT_PERSONAL_TERMS_RESP]: (state, action) => ({
      ...state,
      getPersonalTermsResp: null,
    }),
    [INIT_INSERT_REQST_PROPOSAL_RESP]: (state, action) => ({
      ...state,
      insertReqstProposalResp: null,
    }),
    [INIT_GET_PROPOSAL_PRIVACY_POLICY_RESP]: (state, action) => ({
      ...state,
      getProposalPrivacyPolicyResp: null,
    }),
    [INIT_GET_PROPOSAL_NOTICE_POLICY_RESP]: (state, action) => ({
      ...state,
      getProposalNoticePolicyResp: null,
    }),
    // U001: FAQ 목록 리스트
    [FAQ_INTRO_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getFaqIntroListResp: action.payload,
    }),
    [FAQ_INTRO_LIST_FAILURE]: (state, action) => ({
      ...state,
      getFaqIntroListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U002: 공지사항 인트로 목록 리스트
    [NOTICE_INTRO_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getNoticeIntroListResp: action.payload,
    }),
    [NOTICE_INTRO_LIST_FAILURE]: (state, action) => ({
      ...state,
      getNoticeIntroListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U003: 공지사항 인트로 상세 보기
    [NOTICE_INTRO_DETAIL_VIEW_SUCCESS]: (state, action) => ({
      ...state,
      getNoticeIntroDetailViewResp: action.payload,
    }),
    [NOTICE_INTRO_DETAIL_VIEW_FAILURE]: (state, action) => ({
      ...state,
      getNoticeIntroDetailViewResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U004: 인트로 팝업
    [ALL_NOTICE_POPUP_NON_LOGIN_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getAllNoticePopupNonLoginListResp: action.payload,
    }),
    [ALL_NOTICE_POPUP_NON_LOGIN_LIST_FAILURE]: (state, action) => ({
      ...state,
      getAllNoticePopupNonLoginListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U066: 공지사항 인트로 파일 다운로드
    [NOTICE_INTRO_FILE_DOWN_SUCCESS]: (state, action) => ({
      ...state,
      noticeIntrofileDownResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [NOTICE_INTRO_FILE_DOWN_FAILURE]: (state, action) => ({
      ...state,
      noticeIntrofileDownResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U0104: 스파로스 서비스 소개서 다운로드
    [DOCUMENT_FILE_DOWNLOAD_SUCCESS]: (state, action) => ({
      ...state,
      documentFileDownloadResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [DOCUMENT_FILE_DOWNLOAD_FAILURE]: (state, action) => ({
      ...state,
      documentFileDownloadResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U1310: 인트로 상담신청 - 상담 신청 페이지 정책 조회
    [POLICY_MNGT_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getPolicyMngtListResp: action.payload,
    }),
    [POLICY_MNGT_LIST_FAILURE]: (state, action) => ({
      ...state,
      getPolicyMngtListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U1311. 인트로 상담신청 - 상담 신청 등록
    [INERT_REQST_CONSULT_SUCCESS]: (state, action) => ({
      ...state,
      insertReqstConsultResp: action.payload,
    }),
    [INERT_REQST_CONSULT_FAILURE]: (state, action) => ({
      ...state,
      insertReqstConsultResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U1312: 인트로 상담신청 - 서비스 이용약관
    [TERMS_OF_SERVICE_SUCCESS]: (state, action) => ({
      ...state,
      getTermsOfServiceResp: action.payload,
    }),
    [TERMS_OF_SERVICE_FAILURE]: (state, action) => ({
      ...state,
      getTermsOfServiceResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U1313: 인트로 상담신청 - 개인정보처리방침
    [PERSONAL_TERMS_SUCCESS]: (state, action) => ({
      ...state,
      getPersonalTermsResp: action.payload,
    }),
    [PERSONAL_TERMS_FAILURE]: (state, action) => ({
      ...state,
      getPersonalTermsResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // FAQ 드롭다운 api
    [GET_IFAQ_TYPE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getIFaqTypeListResp: action.payload,
    }),
    [GET_IFAQ_TYPE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getIFaqTypeListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 인트로 서비스 제휴제안 - 제휴제안 등록
    [INERT_REQST_PROPOSAL_SUCCESS]: (state, action) => ({
      ...state,
      insertReqstProposalResp: action.payload,
    }),
    [INERT_REQST_PROPOSAL_FAILURE]: (state, action) => ({
      ...state,
      insertReqstProposalResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 인트로 서비스 제휴제안 - 개인정보 수집 및 이용 동의 정책 조회
    [GET_PROPOSAL_PRIVACY_POLICY_SUCCESS]: (state, action) => ({
      ...state,
      getProposalPrivacyPolicyResp: action.payload,
    }),
    [GET_PROPOSAL_PRIVACY_POLICY_FAILURE]: (state, action) => ({
      ...state,
      getProposalPrivacyPolicyResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 인트로 서비스 제휴제안 - 유의사항 정책 조회
    [GET_PROPOSAL_NOTICE_POLICY_SUCCESS]: (state, action) => ({
      ...state,
      getProposalNoticePolicyResp: action.payload,
    }),
    [GET_PROPOSAL_NOTICE_POLICY_FAILURE]: (state, action) => ({
      ...state,
      getProposalNoticePolicyResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
  },
  initialState
);

export default apiIntroResp;
